import Toaster from "@/components/toaster";
import Protected from "@/pages/protected";
import { DataService } from "@/services/data";
import { CallAccessType } from "@/types/tools/call_access";
import { Outlet, RouteObject, defer, redirect } from "react-router-dom";

const ArchiveCallRoute: RouteObject = {
    path: "archives",
    element: (
        <Protected groups={["app_tools_admin", "team_support", "team_adv"]}>
            <Outlet />
        </Protected>
    ),
    children: [
        {
            index: true,
            async lazy() {
                let { CallAccessCreatePage } = await import("@/pages/tools/call_access/create");
                return { Component: CallAccessCreatePage };
            },
            action: async ({ request }) => {
                const data = await request.json();
                try {
                    const call_access = (await DataService.client.url(`/tools/call_access/`).post(data).json()) as CallAccessType;
                    return redirect(`/outils/appels/archives/${call_access.id}`);
                } catch (e) {
                    console.error(e);
                    Toaster.error(`Une erreur est survenue`);
                    return {};
                }
            }
        },
        {
            path: ":call_access_id",
            loader: async ({ params }) => {
                const call_access = await DataService.client.url(`/tools/call_access/${params.call_access_id}/`).get().json();
                return defer({ call_access });
            },
            async lazy() {
                let { CallAccessSuccessPage } = await import("@/pages/tools/call_access/success");
                return { Component: CallAccessSuccessPage };
            }
        }
    ]
};
export default ArchiveCallRoute;
